import React, { useEffect, useState } from "react";
import {
    CButton,
    CButtonGroup,
    CCard,
    CCardBody,
    CCardFooter,
    CCardText,
    CCardTitle,
    CCol,
    CContainer,
    CFormCheck,
    CFormFloating,
    CFormInput,
    CFormLabel,
    CFormTextarea,
    CInputGroup,
    CInputGroupText,
    CRow,
} from "@coreui/react";
import { useSelector } from "react-redux";
import DatePicker from "react-date-picker";
import store from "../../storeWire";
import {
    toServer,
    destroyFromServer,
    updateField,
} from "../../store/slice/customerLedgerMemo";
import { usePage } from "@inertiajs/inertia-react";
import * as CustomerAccountCommon from "../CustomerAccount/common";
import axios from "axios";
import Helper from "../../application/helper";
import { setData } from "../../store/slice/customerAccount";

const Common = (props) => {
    const p = usePage();
    const [action, setAction] = useState("edit");
    const [readOnly, setReadonly] = useState(false);
    const [initial, setInitial] = useState(false);
    const [customer_account_number, set_customer_account_number] = useState("");
    const d = useSelector((state) => state.entities.customerLedgerMemo);
    const onInputHandle = (value, name) => {
        let formattedValue = value; // Initialize with the value as is
        if (value?.target?.value) {
            formattedValue = value?.target?.value;
        }
        if (name === "created_at") {
            let date = null;

            // Check if the value exists and is a valid date
            if (value) {
                date = new Date(value);
            } else {
                date = new Date();
            }

            // Validate the date
            if (!isNaN(date.getTime())) {
                // If you want to keep the time zone information, you can format the date manually
                const formattedDate =
                    [
                        date.getFullYear(),
                        ("0" + (date.getMonth() + 1)).slice(-2),
                        ("0" + date.getDate()).slice(-2),
                    ].join("-") +
                    " " +
                    [
                        ("0" + date.getHours()).slice(-2),
                        ("0" + date.getMinutes()).slice(-2),
                        ("0" + date.getSeconds()).slice(-2),
                    ].join(":");

                formattedValue = formattedDate;
            } else {
                console.warn("Invalid date provided for 'created_at'");
            }
        }
        store.dispatch(
            updateField({
                field_name: name,
                value: formattedValue,
            })
        );
    };
    let getDate__created_at = () => {
        if (d?.created_at) {
            return new Date(d?.created_at);
        }
        return new Date();
    };
    useEffect(() => {
        if (p.props.customer_ledger_memo) {
            setAction("edit");
        }
        if (p.props.current_route_name === "customer-ledger-memo.delete") {
            setAction("delete");
        }
        if (props.action !== undefined) {
            setAction(props.action);
        }
        if (p.props.action !== undefined) {
            setAction(p.props.action);
        }
    }, []);
    useEffect(() => {
        if (
            action === "delete" ||
            action === "approve" ||
            action === "reject"
        ) {
            setReadonly(true);
        }
        if (initial === false) {
            setCustomerAccountData();
        }
    });
    const submitForm = () => {
        store.dispatch(toServer());
    };
    const approveForm = async () => {
        await store.dispatch(
            updateField({
                field_name: "approve_action",
                value: "auto",
            })
        );
        await store.dispatch(toServer());
    };
    const rejectForm = () => {
        store.dispatch(
            updateField({
                field_name: "reject_action",
                value: "auto",
            })
        );
        store.dispatch(toServer());
    };
    const setCustomerAccountData = () => {
        if (
            d.customer_account !== undefined &&
            d.customer_account.customer_account_number !== undefined
        ) {
            setInitial(true);
            getCustomerAccountNumber(
                d.customer_account.customer_account_number
            );
            set_customer_account_number(
                d.customer_account.customer_account_number
            );
        }
    };
    const destroyForm = () => {
        store.dispatch(destroyFromServer());
    };
    const getCustomerAccountNumber = (customer_account_number) => {
        if (
            customer_account_number &&
            customer_account_number.length > 1 &&
            customer_account_number.length < 15
        ) {
            axios
                .get(
                    Helper.route("customeraccount.show", {
                        customeraccount: customer_account_number,
                    })
                )
                .then((res) => {
                    if (res.data.data.id !== undefined && res.data.data.id) {
                        store.dispatch(setData(res.data.data));
                        store.dispatch(
                            updateField({
                                field_name: "customer_account_id",
                                value: res.data.data.id,
                            })
                        );
                    } else {
                        store.dispatch(setData({}));
                        store.dispatch(
                            updateField({
                                field_name: "customer_account_id",
                                value: "",
                            })
                        );
                    }
                })
                .catch(() => {
                    store.dispatch(setData({}));
                    store.dispatch(
                        updateField({
                            field_name: "customer_account_id",
                            value: "",
                        })
                    );
                });
        }
    };
    const backToHome = () => {
        window.history.back();
    };
    return (
        <>
            <CContainer fluid={true}>
                <CRow>
                    <CCard>
                        <CCardBody>
                            <CCardTitle>
                                Ledger Memo
                                {d["customer_ledger_memo_number"] !==
                                    undefined &&
                                    d["customer_ledger_memo_number"] && (
                                        <>
                                            <CButton
                                                color="info"
                                                className={"float-end"}
                                            >
                                                {
                                                    d[
                                                        "customer_ledger_memo_number"
                                                    ]
                                                }
                                            </CButton>
                                        </>
                                    )}
                            </CCardTitle>
                            <CCardText>
                                Basic Information Regarding Customer which will
                                be used for Ledger Keeping and more.
                            </CCardText>
                            <FormFields
                                d={d}
                                readOnly={readOnly}
                                getDate__created_at={getDate__created_at}
                                onInputHandle={onInputHandle}
                                getCustomerAccountNumber={
                                    getCustomerAccountNumber
                                }
                                customer_account_number={
                                    customer_account_number
                                }
                            />
                        </CCardBody>
                        <CCardFooter>
                            <CRow>
                                <CCol>
                                    <CButtonGroup
                                        role="group"
                                        aria-label="Basic mixed styles example"
                                    >
                                        {action === "edit" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    submitForm();
                                                }}
                                                component="input"
                                                type="submit"
                                                color="primary"
                                                value="Submit"
                                            />
                                        )}
                                        {action === "approve" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    approveForm();
                                                }}
                                                component="input"
                                                type="submit"
                                                color="success"
                                                value="Approve"
                                            />
                                        )}
                                        {action === "reject" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    rejectForm();
                                                }}
                                                component="input"
                                                type="submit"
                                                color="danger"
                                                value="Reject"
                                            />
                                        )}
                                        {action === "search" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    props.onSearch(d);
                                                }}
                                                component="input"
                                                type="submit"
                                                color="primary"
                                                value="Search"
                                            />
                                        )}
                                        {action !== "search" && (
                                            <CButton
                                                size="lg"
                                                onClick={() => {
                                                    backToHome();
                                                }}
                                                component="input"
                                                type="submit"
                                                color="secondary"
                                                value="Back"
                                            />
                                        )}
                                    </CButtonGroup>
                                </CCol>

                                {d.id !== undefined && action === "delete" && (
                                    <CCol>
                                        <CButton
                                            size="lg"
                                            onClick={() => {
                                                destroyForm();
                                            }}
                                            component="input"
                                            type="submit"
                                            color="danger"
                                            value="Destroy"
                                            className={"float-end"}
                                        />
                                    </CCol>
                                )}
                            </CRow>
                        </CCardFooter>
                    </CCard>
                </CRow>
            </CContainer>
            <CustomerAccountCommon.default action={"search"} readOnly={true} />
        </>
    );
};

export const FormFields = ({
    d,
    readOnly,
    onInputHandle,
    getCustomerAccountNumber = undefined,
    getDate__created_at = undefined,
    name_for_created_at = "created_at",
    customer_account_number,
}) => {
    const calculateAmount = (amount, percentage) => {
        return Math.round((amount * percentage) / 100);
    };

    const percentageAmount = calculateAmount(d.amount || 0, d.percentage || 0);

    useEffect(() => {
        onInputHandle(percentageAmount, "percentage_amount");
    }, [percentageAmount]);
    return (
        <>
            {getCustomerAccountNumber && (
                <CRow>
                    <CCol sm={12} md={12} className={"mt-4"}>
                        <CButton size={"sm"} color={"warning"}>
                            Provide Customer Number Example #UYS753GH, Also
                            double check it before creating memo because it will
                            be used to create transaction.
                        </CButton>
                    </CCol>
                    <CCol sm={12} md={12} className={"mt-1"}>
                        <CFormFloating className="mb-3">
                            <CInputGroup>
                                <CFormInput
                                    onChange={(e) => {
                                        getCustomerAccountNumber(
                                            e.target.value
                                        );
                                    }}
                                    disabled={readOnly}
                                    readOnly={readOnly}
                                    defaultValue={customer_account_number || ""}
                                />
                            </CInputGroup>
                        </CFormFloating>
                    </CCol>
                    <CCol sm={12} className={"mt-1"}>
                        <CFormFloating className="mb-3">
                            <CInputGroup>
                                <CInputGroupText>Note</CInputGroupText>
                                <CFormTextarea
                                    aria-label="With textarea"
                                    onChange={(e) => {
                                        onInputHandle(e, "note");
                                    }}
                                    disabled={readOnly}
                                    readOnly={readOnly}
                                    defaultValue={d["note"] || ""}
                                />
                            </CInputGroup>
                        </CFormFloating>
                    </CCol>
                </CRow>
            )}
            <CRow>
                <CCol sm={12} md={4}>
                    <CFormFloating className="mb-3">
                        <CFormInput
                            type="number"
                            value={d?.amount || 0}
                            onChange={(e) =>
                                onInputHandle(
                                    {
                                        target: {
                                            value: e.target.value,
                                        },
                                    },
                                    "amount"
                                )
                            }
                            disabled={readOnly}
                            readOnly={readOnly}
                        />
                        <CFormLabel htmlFor="floatingInput">Amount</CFormLabel>
                    </CFormFloating>
                </CCol>
                <CCol sm={12} md={4}>
                    <CFormFloating className="mb-3">
                        <CFormInput
                            type="number"
                            step="0.01"
                            value={d?.percentage || 0}
                            onChange={(e) =>
                                onInputHandle(
                                    {
                                        target: {
                                            value: parseFloat(e.target.value),
                                        },
                                    },
                                    "percentage"
                                )
                            }
                            disabled={readOnly}
                            readOnly={readOnly}
                        />
                        <CFormLabel htmlFor="floatingInput">
                            Percentage of Interest
                        </CFormLabel>
                    </CFormFloating>
                </CCol>
                <CCol sm={12} md={4}>
                    <CFormFloating className="mb-3">
                        <CFormInput
                            type="number"
                            value={percentageAmount}
                            disabled={readOnly}
                            readOnly={true}
                        />
                        <CFormLabel htmlFor="floatingInput">
                            Percentage Amount
                        </CFormLabel>
                    </CFormFloating>
                </CCol>
            </CRow>
            {getDate__created_at && (
                <CRow>
                    <CCol>
                        <CInputGroup className="mb-3">
                            <CButton color="warning">
                                Memo Creation Date
                            </CButton>
                            <DatePicker
                                disabled={readOnly}
                                onChange={(e) => {
                                    onInputHandle(e, name_for_created_at);
                                }}
                                value={getDate__created_at() || ""}
                                className={"form-control"}
                            />
                        </CInputGroup>
                    </CCol>
                    <CCol>
                        <CFormLabel htmlFor="basic-url">
                            Transaction Type
                        </CFormLabel>
                        <CFormFloating>
                            <CFormCheck
                                inline
                                type="radio"
                                name="transaction_type"
                                value="deposit"
                                label="Deposit"
                                onChange={(e) => {
                                    onInputHandle(e, "transaction_type");
                                }}
                                disabled={readOnly}
                                readOnly={readOnly}
                                defaultChecked={
                                    d["transaction_type"] &&
                                    d["transaction_type"] === "deposit"
                                }
                            />
                            <CFormCheck
                                inline
                                type="radio"
                                name="transaction_type"
                                value="withdrawal"
                                label="Withdrawal"
                                onChange={(e) => {
                                    onInputHandle(e, "transaction_type");
                                }}
                                disabled={readOnly}
                                readOnly={readOnly}
                                defaultChecked={
                                    d["transaction_type"] &&
                                    d["transaction_type"] === "withdrawal"
                                }
                            />
                        </CFormFloating>
                    </CCol>
                </CRow>
            )}
        </>
    );
};
export default Common;
